// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/textfield/Invalid.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { TextField } from '@sail/ui';
export const Invalid = () => <TextField label="Current year" defaultValue="1892" invalid />;